/** Parse / toggle CCC motivo selections (workspace tabs + envio/assinado forms). */

export function readWorkspaceMotivoKeys(
  data?: { motivo_keys?: string[] | null; motivo_key?: string | null } | null
): string[] {
  if (!data) return [];
  if (Array.isArray(data.motivo_keys)) {
    const keys = data.motivo_keys.map((k) => String(k).trim()).filter(Boolean);
    if (keys.length) return keys;
  }
  const single = (data.motivo_key || '').trim();
  return single ? [single] : [];
}

export function readFlatMotivoKeys(
  data: Record<string, unknown> | null | undefined,
  keysField: string,
  legacyField: string
): string[] {
  if (!data) return [];
  const keys = data[keysField];
  if (Array.isArray(keys)) {
    const parsed = keys.map((k) => String(k).trim()).filter(Boolean);
    if (parsed.length) return parsed;
  }
  const single = String(data[legacyField] ?? '').trim();
  return single ? [single] : [];
}

export function toggleMotivoKey(selected: string[], key: string): string[] {
  const normalized = key.trim();
  if (!normalized) return selected;
  return selected.includes(normalized)
    ? selected.filter((k) => k !== normalized)
    : [...selected, normalized];
}

export function hasMotivoKey(selected: string[], key: string): boolean {
  return selected.includes(key.trim());
}

export function hasAnyMotivoKey(selected: string[]): boolean {
  return selected.some((k) => k.trim());
}
